



















import { Component, Vue, Prop, Watch } from 'nuxt-property-decorator'
import { PRODUCTS_ADDITIONAL_API } from '~/assets/config/api-path'
import { IProduct } from '~/assets/interfaces/products'

@Component({
  components: {
    ComponentProductAdditional: () =>
      import('~/components/products/product-additional.vue'),
  },
})
export default class ComponentProductAdditionalWrapper extends Vue {
  @Prop({ type: Number, default: 0 }) private blockId!: number
  @Prop({ type: String, default: '' }) private entity!: string
  @Prop({ type: String, default: '' }) private entityId: number | string
  @Prop({ type: String, default: '' }) private position: string
  @Prop({ type: Boolean, default: false }) private intersect: boolean

  private items: IProduct[] = []
  private title = ''
  private url = ''
  private type = 'table'
  private pages = 1
  private perPage = 1
  private currentPage = 1
  private desktopBgImage = null
  private mobileBgImage = null

  private dataIsLoaded = false
  private loading = false

  // Товары приходят с сервера: блок, догружаемый в браузере, сдвигал
  // всё ниже себя, в том числе подвал (CLS)
  async fetch() {
    await this.getData()
  }

  @Watch('dataIsLoaded', { immediate: true })
  private dataIsLoadedHandler(val: boolean) {
    if (val) {
      this.$emit('loaded')
    }
  }

  private async getData(concat: boolean = false) {
    if (!this.loading) {
      this.loading = true
      if (concat) this.currentPage++
      let params = {
        page: this.currentPage,
        entity: this.entity,
      }
      if (this.entityId) {
        params = Object.assign(params, { entityId: this.entityId })
      }
      if (this.position) {
        params = Object.assign(params, { position: this.position })
      }
      const response = await this.$axios.$get(
        `${PRODUCTS_ADDITIONAL_API}/${this.blockId}/`,
        { params }
      )
      this.title = response.title || ''
      this.url = response.url || ''
      this.type = response.type || 'table'
      this.pages = response.pages
      this.perPage = response.perPage
      this.desktopBgImage = response.desktopBgImage || null
      this.mobileBgImage = response.mobileBgImage || null
      if (concat) {
        this.items = this.items.concat(response.items)
      } else {
        this.items = response.items
      }
      this.loading = false
      this.dataIsLoaded = true
      this.currentPage++
    }
  }
}
